import React, { useState } from "react";
import SearchBar from "../../components/SearchBar";
import Navbar from "../../components/Navbar";
import hamburger_icon from "../../assets/icons/hamburger_icon.png";
import bi_filter from "../../assets/icons/bi_filter.png";
import tasks_completion_graph_image from "../../assets/images/tasks_completion_graph_image.png";
import converstion_ratio_image from "../../assets/images/converstion_ratio_image.png";
import conversion_ratio_exhibition from "../../assets/images/conversion_ratio_exhibition.png";
import data_updating__image from "../../assets/images/data_updating__image.png";
import overview_graph_image from "../../assets/images/overview_graph_image.png";
import ReportFilterModal from "../../components/modals/ReportFilterModal";

const AdminReportSegment = () => {
  const [activeSection, setActiveSection] = useState("Task");
  const [isNavbarVisible, setIsNavbarVisible] = useState(false);
  const [filter, setFilter] = useState(false);

  const handleTabClick = (tab) => {
    setActiveSection(tab);
  };

  const toggleNavbar = () => {
    setIsNavbarVisible(!isNavbarVisible);
  };

  return (
    <div>
      <div className="flex items-center justify-center w-full">
        <div
          className="items-center justify-center hidden hamburger"
          onClick={toggleNavbar}
        >
          <img
            src={hamburger_icon}
            className="object-contain"
            alt="hamburger"
          />
        </div>
        <div className="flex items-center justify-center w-full">
          <SearchBar categoryName="Dashboard" />
        </div>
        <div className="absolute top-0 w-[70%] z-20 bg-white rounded-lg mt-16">
          {isNavbarVisible && <Navbar />}
        </div>
      </div>

      <div className="flex items-center">
        <div className="ml-4 bg-[#FFF9E9] w-[90%]  shadow-sm my-6">
          <div className="flex text-[#49454F] text-[12px] justify-around h-10">
            <div
              className="flex flex-col justify-between pt-3 cursor-pointer"
              onClick={() => handleTabClick("Task")}
            >
              <p
                className={`${
                  activeSection === "Task" ? "text-[#2F80ED]" : ""
                } `}
              >
                Task
              </p>
              {activeSection === "Task" ? (
                <div className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}></div>
              ) : null}
            </div>
            <div
              className="flex flex-col justify-between pt-3 cursor-pointer"
              onClick={() => handleTabClick("Exhibitions")}
            >
              <p
                className={`${
                  activeSection === "Exhibitions" ? "text-[#2F80ED]" : ""
                } `}
              >
                Exhibitions
              </p>
              {activeSection === "Exhibitions" ? (
                <div className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}></div>
              ) : null}
            </div>
            <div
              className="flex flex-col justify-between pt-3 cursor-pointer"
              onClick={() => handleTabClick("Prospects")}
            >
              <p
                className={`${
                  activeSection === "Prospects" ? "text-[#2F80ED]" : ""
                } `}
              >
                Prospects
              </p>
              {activeSection === "Prospects" ? (
                <div className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}></div>
              ) : null}
            </div>
            <div
              className="flex flex-col justify-between pt-3 cursor-pointer"
              onClick={() => handleTabClick("Customers")}
            >
              <p
                className={`${
                  activeSection === "Customers" ? "text-[#2F80ED]" : ""
                } `}
              >
                Customers
              </p>
              {activeSection === "Customers" ? (
                <div className={` h-1 bg-[#2F80ED] rounded-t-lg w-full`}></div>
              ) : null}
            </div>
          </div>
        </div>
        <div className=" ml-4" onClick={() => setFilter(!filter)}>
          <img src={bi_filter} alt="filter" className="cursor-pointer" />
        </div>
        <div className="absolute right-0 top-32 w-[15%] bg-white card--one">
          {filter ? <ReportFilterModal /> : null}
        </div>
      </div>
      <div className="flex justify-end w-[95%]">
        <div className="flex items-center px-4 bg-white shadow-lg border border-[#F7F1E1] rounded-lg cursor-pointer mr-2 text-[#3485BB]">
          <div className="text-[12px]">Weekly</div>
          <span className="text-md ml-2 mb-3 font-semibold">&#x2304;</span>
        </div>
      </div>

      {/* Task */}
      {activeSection === "Task" ? (
        <div className="mt-4 ml-4 w-[95%]">
          <div className="flex justify-between flex--cards">
            <img
              src={tasks_completion_graph_image}
              alt="graph"
              className="object-contain w-[58%] card--one"
            />
            <img
              src={converstion_ratio_image}
              alt="graph"
              className="object-contain w-[38%] card--one"
            />
          </div>
          <div className="mt-4">
            <img
              src={data_updating__image}
              alt="graph"
              className="w-[58%] card--one"
            />
          </div>
        </div>
      ) : null}

      {/* Exhibitions */}
      {activeSection === "Exhibitions" ||
      activeSection === "Prospects" ||
      activeSection === "Customers" ? (
        <div className="mt-4 ml-4 w-[90%]">
          <div className="flex justify-between flex--cards">
            <img
              src={conversion_ratio_exhibition}
              alt="graph"
              className="object-contain w-[55%] card--one"
            />
            <img
              src={overview_graph_image}
              alt="graph"
              className="w-[38%] object-contain"
            />
          </div>
        </div>
      ) : null}

      <div className="border border-[#2F80ED] my-8 text-center ml-4 w-[90%] rounded-lg p-1">
        <button className="text-[#2F80ED] text-[16px] font-bold">
          Download Report
        </button>
      </div>
    </div>
  );
};

export default AdminReportSegment;
